<template>
  <div class="col-12 mt-5">
  
    <h4 class="stage-results__title">{{'protocol.title_chain' | trans}} {{stage.description}}</h4>
    <table-view
        :options="options"
        :isChange="isChange"
        :isList=isMobile
        class="stimulus_table"
    >
  
      <div slot="name" slot-scope="props">
        {{props.row.name}}
        <div v-if="!props.row.active">{{'protocol.disable' | trans}}</div>
      </div>
      
      <div slot="motivationCondition" slot-scope="props" class="nowrap">
        <div v-if="props.row.motivationCondition">{{'admin.yes' | trans }}</div>
        <div v-if="!props.row.motivationCondition">{{'admin.no' | trans }}</div>
      </div>
    
      <div slot="action" slot-scope="props">
        <div v-if="props.row.name">
        
          <mdc-checkbox :checked="checkedStimulus(props.row.id)"
                        @change="choseStimulus(props.row, $event)"
                        :disabled="chosenStimul.length == 4 && !checkedStimulus(props.row.id)"/>
        </div>
      </div>
  
    </table-view>
    
    <div class="row">
      <div class="col-12 text-right">
        <button type="button"
                class="btn btn-primary mt-5 mt-sm-0 mb-2 mb-sm-0" raised
                @click.prevent="chartShow()">
          {{'report.show_graph_btn' | trans}}
        </button>
      </div>
    </div>
    
    <div class="row mt-3">
      
      <div class="col-12" v-if="chartDatasetsForStimul && chartDatasetsForStimul.chartData && chartDatasetsForStimul.chartData.length && chartDatasetsForStimulDataset" :class="{'mb-1': isChangeStimuli}">
    
        <div class="row position-relative" >
          <loader v-if="!loaded"  class="table-loader"></loader>
          <div :class="{'col-md-9' : (chartDatasetsForStimul.chartData.length === 1), 'col-md-12' : chartDatasetsForStimul.chartData.length !== 1  }">
            <line-chart class="row" v-bind:datasets="chartDatasetsForStimulDataset"
                        :scale-label="'protocol.total_percent' | trans"
                        :stage-info="stage.id"
                        v-bind:list-chart-date="chartDatasetsForStimul.labels"
                        v-bind:many-chart="chartDatasetsForStimul.chartData.length > 1"
                        v-bind:show-legend="chartDatasetsForStimul.chartData.length > 1"
                        v-bind:y-axes-begin-at-zero="true"
                        v-bind:vertical-line-point=changesLine
                        v-bind:linedatasets="trendLinePoint"
                        v-on:popup-show="popupShow"
                        :persentMax=persentMax
                        :labelText="'%'"
                        :is-mobile="isMobile"
                        :aspect-ratio=false
                        :height="340"
                        :width=null
            />
            <h4 class="chart__title mb-3">
              {{'protocol.stimulus_mastering_chart' | trans }}
              <span v-for="(stimul, index) in chartDatasetsForStimulDataset">{{stimul.label}}<span
                  v-if="index < chartDatasetsForStimulDataset.length -1">, </span></span>.
            </h4>
      
          </div>
          <div class="mt-3 col-md-3" v-if="chartDatasetsForStimul.chartData.length === 1">
            <mdc-switch v-model="levelLineChecked">{{ 'protocol.levelLine' | trans }}</mdc-switch>
            <mdc-switch v-model="trendLineChecked">{{ 'protocol.trendLine' | trans }}</mdc-switch>
            <mdc-switch v-model="ScatterLineChecked">{{ 'protocol.scatterLine' | trans }}</mdc-switch>
          </div>
        </div>
      </div>
  
      <div class="col-md-12 text-center" v-if="chosenStimul.length && withoutData">
        <h5>{{'protocol.no_data' | trans }} <span v-for="(stimul, index) in chosenStimul">{{stimul.name}}<span
            v-if="index < chosenStimul.length -1">, </span></span>.</h5>
      </div>
      
    </div>
  
    <div v-if="isModalVisible">
    
    
      <chart-popup :visible="isModalVisible"
                   :isChain="true"
                   :isStageChain="true"
                   chartType="1"
                   :stimulId="chosenStimul[0].id"
                   v-on:close="onClose"
                   :stage-id="selectedStageId"
                   :graphTitle="'protocol.stimulus_mastering_chart' | trans"
                   :protocolId="protocolId"
                   :dataPoint="dataPoint">
      </chart-popup>
  
    </div>

  </div>
</template>

<script>

  import axios from 'axios';
  import {mapGetters} from 'vuex';
  import TableView from '../../../common/table/components/TableView';
  import lang from '../../../lang/translator';
  import moment from 'moment';
  import forEach from 'lodash/forEach';
  import filter from 'lodash/filter';
  import map from 'lodash/map';
  import {LineNonNumericYChart, LineChart, LineChartDataset} from '../../../common/chart';

  import Loader from '../../loader/components/Loader';
  import ChartPopup from './ChartPopup';
  import {chartStage} from '../../../mixins/chartStage';
  
  export default {
    props: ['stage', 'protocolId', 'rangeDateStartTimestamp', 'rangeDateEndTimestamp'],
    components: {
      TableView, LineChart, Loader, ChartPopup
    },

    mixins: [chartStage],

    data() {
      return {
        isChange: false,
        isChangeStimuli: false,
        list: [],
        options: {
          pageHeader: 'chainList',
          initialPage: null,
          perPage: 10,
          pagination: {
            chunk: 20,
          },
          filterable: false,
          debounce: 1000,
          sortable: [],
          withSearch: false,
          skin: 'table table-sm',
          columns: [
            {
              key: 'name',
              changed: true,
              headings: lang.get('protocol.name_step')
            },
            {
              key: 'stage',
              changed: false,
              headings: lang.get('protocol.environment')
            },
            {
              key: 'startedAt',
              changed: false,
              headings: lang.get('protocol.started_at')
            },
            {
              key: 'masteredAt',
              changed: false,
              headings: lang.get('protocol.date_mastering')
            },
            {
              key: 'countSamples',
              changed: false,
              headings: lang.get('protocol.countSamples')
            },
            {
              key: 'action',
              changed: true,
              headings: lang.get('protocol.choose_stimul_chart')
            }
          ],
          templates: {
            masteredAt: this.masteredAt,
            startedAt: this.startedAt,
          },
          listRow: {
            name: {
              headings: lang.get('protocol.name_step'),
              hasTemplate: false,
            },
            stage: {
              headings: lang.get('protocol.environment'),
              hasTemplate: false,
            },
            startedAt: {
              headings: lang.get('protocol.started_at'),
              hasTemplate: true,
            },
            masteredAt: {
              headings: lang.get('protocol.date_mastering'),
              hasTemplate: true,
            },
            countSamples: {
              headings: lang.get('protocol.countSamples'),
              hasTemplate: false,
            },
          },
          requestFunction: this.requestFunction,
          responseAdapter: function (resp) {
            return {
              data: resp.data.data.items,
              count: resp.data.data.total
            }
          },
          texts: {
            filter: "",
            filterPlaceholder: lang.get('user.type_the_client_code_to_search'),
            noResults: lang.get('bids.no_data'),
            loading: lang.get('home.labels.loading_message_table'),
            count: "Страница {page} из {pages}",
          },
          columnsClasses: {
            answerTitle: 'text-center',
            mandLevel: 'text-center',
            motivationCondition: 'text-center',
            countSamples: 'text-center',
          },
          rowClassCallback(row) {
            return row.checked ? "table-info" : "";
          }
        },
        apiUrl: '/protocols/assigned/',
        loaded: true,
        selectedStageId: null,
        apiChartUrl: '/protocols/assigned/chain/',

      };
    },

    computed: {

      ...mapGetters('mobile', [
        'isMobile',
      ]),
      
    },

    async created() {
    
    },

    methods: {

      toLocaleDate: function (date) {
        return moment(date, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY');
      },

      startedAt(h, row) {
        return row.startedAt ? this.toLocaleDate(row.startedAt.date) : '';
      },

      masteredAt(h, row) {
        return row.masteredAt ? this.toLocaleDate(row.masteredAt.date) : '';
      },

      async requestFunction (data) {
        this.isChange = false;
        localStorage.setItem('currentPage', data.page);
        localStorage.setItem('currentPageHeader', 'chainList');
        return this.onSendRequest(this.options.perPage, data.page);
      },

      onSendRequest: async function (perPage, page) {
        this.list = [];

        let url = this.apiUrl + 'chain/' + this.protocolId + '/stimuli-introduced-mastered-history/';

        let params = {
          perPage: perPage,
          page: page,
          stageId: this.stage.id,
        };
        let response = await axios.get(url, {params: params});
        this.list = response.data.data.items;
        return response;
      },

      
    },

  };
</script>



// WEBPACK FOOTER //
// src/modules/dashboardParent/components/CurrentStageChain.vue